import { database } from '../index';
import { USER_SCHEMA } from '../schema';
import { Q } from '@nozbe/watermelondb';

const user = database.collections.get(USER_SCHEMA)

export const observeUser = () => user.query().observeWithColumns(['name', 'phone_number', 'device_token', 'telco_network', 'referral'])

export const getUserFromNumber = async (number) => await user.query(Q.where('phone_number', number)).fetch()

export const findUserByID = async (id) => await user.find(id);

export const getUserFromId = async (id) => await user.query(Q.where('id', id)).fetch()

export const observeActiveUser = (number) => user.query(Q.where('phone_number', number), Q.where('is_active', true)).observeWithColumns(['name', 'phone_number', 'device_token', 'telco_network', 'referral'])
export const getActiveUser = (number) => user.query(Q.where('phone_number', number), Q.where('is_active', true)).fetch()

export const getUserFromNumberAndCode = async (number, activation_code) => await user.query(Q.where('phone_number', number), Q.where('activation_code', activation_code)).fetch()

export const getAllUser = async () => await user.query().fetch()

export const updateReferral = async (number, ref) => {
    await database.write(async () => {
        const findUser = await user.query(Q.where('phone_number', number)).fetch()

        if (findUser.length && !findUser[0].referral) {
            await findUser[0].update(entry => {
                entry.referral = ref
            })
        }
    })
}

export const createUser = async (newUser) => {
    return await database.write(async () => {
        return await user.create(entry => {
            entry._raw.id = newUser.id
            entry.name = newUser.name
            entry.phone_number = newUser.phone_number
            entry.telco_network = newUser.telco_network
            entry.referral = newUser.referer
            entry.activation_code = newUser.activation_code
            entry.is_active = newUser.is_active
        })
    })
}


